import clsx, { type ClassValue } from 'clsx';

/** Class-name join. Thin alias so components never import clsx directly. */
export function cn(...values: ClassValue[]): string {
  return clsx(...values);
}
